module.exports = __webpack_public_path__ + "img/undraw_empty.90bc0a2c.svg";